export class InvoiceReplacement {
  formTplId: number;
  name: string;
}
